import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Swal from 'sweetalert2';
import { HTTP } from "../../api/http-common";
import { CommonGoBackButton, CommonTitle } from "../../components/commonComponents";
import { GoTrophy } from "react-icons/go";

const WinnerPredictionScreen = () => {
  const navigate = useNavigate();
  const handleBack = () => {
    navigate(-1);
  };
  const { id } = useParams();
  const access_token = localStorage.getItem('access_token');
  const episodeid = id;
  const [submittedWinners, setSubmittedWinners] = useState([]);
  const [showTrophies, setShowTrophies] = useState(false);
  const [isHandleSubmit, setisHandleSubmit] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [warning, setWarning] = useState(false);
  const [predictWinnersData, setPredictWinnersData] = useState({
    name: '',
    startDatetime: '',
    endDatetime: '',
    videoId: '',
    participantsCount: 0,
    isVotingLineOpen: false,
    isActive: false,
    participants: [],
    selectedParticipants: [],
    participationUserIDs: [],
  });

  const [winnerSubmission, setWinnerSubmission] = useState({
    episode_id: id,
    winner_ids: [],
  });

  const SelectedWinner = predictWinnersData.selectedParticipants;

  const handleCheckboxChange = (userId) => {
    const selectedCount = SelectedWinner.filter(p => p.isWinner).length;

    const updatedParticipants = SelectedWinner.map(participant => {
      if (participant.user_id === userId) {
        const willCheck = !participant.isWinner;
        if (willCheck && selectedCount >= 4) {
          return participant;
        }
        return { ...participant, isWinner: willCheck };
      }
      return participant;
    });

    setPredictWinnersData(prevData => ({
      ...prevData,
      selectedParticipants: updatedParticipants,
    }));

    const finalWinners = updatedParticipants
      .filter(p => p.isWinner)
      .map(p => p.user_id);

    setWinnerSubmission(prev => ({
      ...prev,
      winner_ids: finalWinners,
    }));

    setWarning(finalWinners.length !== 4);
  };

  const handleSubmit = async () => {
    if (winnerSubmission.winner_ids.length !== 4) {
      setWarning(true);
      return;
    }
    const formattedWinnerSubmission = {
      ...winnerSubmission,
      winner_ids: winnerSubmission.winner_ids.join(','),
    };

    try {
      const response = await HTTP.post(
        `/amazing_adanians/participation/winner/prediction/submit`,
        formattedWinnerSubmission,
        {
          headers: {
            "Content-Type": "application/json",
            token: access_token,
          },
        }
      );

      if (response.status === 200 || response.status === 201) {
        setShowTrophies(true);
        setSubmittedWinners(response.data.content || []);
        setisHandleSubmit(true);
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Error!',
          text: 'There was an error submitting your result.',
        });
      }
    } catch (error) {
      console.error("Submission error:", error);
      Swal.fire({
        icon: 'error',
        title: 'Error!',
        text: 'An unexpected error occurred. Please try again.',
      });
    }
  };

  const loadEpisodeData = async () => {
    setIsLoading(true);
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
          token: access_token,
        },
      };

      const response = await HTTP.get(`amazing_adanians/episode/master/${episodeid}`, config);

      if (response.status === 200) {
        const data = response.data.content;

        const formattedSelected = data.selected_participants_data.map(p => ({
          ...p,
          isWinner: p.isWinner || false,
        }));

        const userIDs = formattedSelected.map(p => p.user_id);

        setPredictWinnersData({
          name: data.name,
          startDatetime: data.start_datetime_utc,
          endDatetime: data.end_datetime_utc,
          videoId: data.video_id,
          participantsCount: data.participants_count,
          isVotingLineOpen: data.is_voting_line_open,
          isActive: data.is_active,
          participants: data.participants,
          selectedParticipants: formattedSelected,
          participationUserIDs: userIDs,
        });

        console.log('Loaded Selected Participants:', formattedSelected);
      } else if (response.status === 204) {
        Swal.fire("", "Episode Not Found", "error");
      }
    } catch (err) {
      setError(err);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    loadEpisodeData();
  }, []);

  // Export CSV function for .winner-list table
  const exportTableToCSV = () => {
    const table = document.querySelector('.winner-list');
    if (!table) {
      Swal.fire('Error', 'Winner list table not found', 'error');
      return;
    }

    let csv = [];
    const rows = table.querySelectorAll('tr');

    for (let i = 0; i < rows.length; i++) {
      const row = [], cols = rows[i].querySelectorAll('td, th');
      for (let j = 0; j < cols.length; j++) {
        let data = cols[j].innerText.replace(/"/g, '""');
        row.push(`"${data}"`);
      }
      csv.push(row.join(','));
    }

    const csvString = csv.join('\n');
    const blob = new Blob([csvString], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.setAttribute('hidden', '');
    a.setAttribute('href', url);
    a.setAttribute('download', `winner_list_episode_${id}.csv`);
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  };

  return (
    <div>
      <div className="mb-2 d-flex justify-content-between align-items-center">
        <CommonTitle PageTitle="Winners Predict" />
        <CommonGoBackButton/>
        {/* <button className="custom-back-button" onClick={handleBack}> Back</button> */}
      </div>

      <div className="winner-prediction-wrapper">
        <div className="border winner-prediction-episode-detail">
          <div className="row">
            <div className="col-md-6">
              <p>Episode Name: <span>{predictWinnersData.name}</span></p>
            </div>
            <div className="col-md-6">
              <p>Episode ID: <span>{id}</span></p>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6">
              <p>Start Date: <span>{predictWinnersData.startDatetime}</span></p>
            </div>
            <div className="col-md-6">
              <p>End Date: <span>{predictWinnersData.endDatetime}</span></p>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6">
              <p>Video ID: <span>{predictWinnersData.videoId}</span></p>
            </div>
            <div className="col-md-6">
              <p>Participants Count: <span>{predictWinnersData.participantsCount}</span></p>
            </div>
          </div>
        </div>

        <div className="table-wrapper">
          <div className="demo-download-wrapper d-flex align-items-center participant-list-title ">
            <CommonTitle PageTitle="Participants List" />
            <span className={`winner-predict-select-text ms-2 ${warning ? 'text-danger' : 'text-secondary'}`}>
              Choose exactly 4 winners from the list below
            </span>
          </div>

          <table className="table table-bordered participants-table custom-participants-table-wrapper">
            <thead>
              <tr>
                <th className="text-center">Participants</th>
              </tr>
            </thead>
            <tbody>
              {SelectedWinner.map((participant) => (
                <tr key={participant.user_id}>
                  <td>
                    <div className="d-flex align-items-center justify-content-between">
                      <span className={`${showTrophies && participant.isWinner && 'bg-light-success'} d-flex align-items-center`}>
                        <span className={`${showTrophies && participant.isWinner && 'text-success'}`}>{participant.name}</span>
                        {showTrophies && participant.isWinner && (
                          <span className="ms-2"><GoTrophy /></span>
                        )}
                      </span>
                      <span>
                        <input
                          type="checkbox"
                          checked={participant.isWinner}
                          onChange={() => handleCheckboxChange(participant.user_id)}
                        />
                        {" "}Winner
                      </span>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="mt-3 d-flex justify-content-center">
          <button
            type="button"
            className="form-submit button-design"
            onClick={handleSubmit}
          >
            Submit
          </button>
        </div>

        {isHandleSubmit == 1 && (
          <div className="mt-4">
            <div className="d-flex justify-content-end mb-2">
              <button className="button-design px-3 py-2" onClick={exportTableToCSV}>
                Export Winners CSV
              </button>
            </div>

            {submittedWinners.length > 0 ? (
              <table className="table table-bordered winner-list">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Contact No</th>
                    <th>Employee ID</th>
                    <th>Vote Time</th>
                  </tr>
                </thead>
                <tbody>
                  {submittedWinners.map((winner) => (
                    <tr key={winner.user_id}>
                      <td>{winner.name}</td>
                      <td>{winner.email}</td>
                      <td>{winner.contact_no}</td>
                      <td>{winner.employee_id}</td>
                      <td>{winner.first_vote_time}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <h4 className="text-center bg-secondary mt-3"> No Users Found </h4>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default WinnerPredictionScreen;

